import React from 'react';
import HotSearch from './HotSearch';
import DailyEnglish from './daily-english/DailyEnglish';
import './CardComponent.css';
import languageManager from '../../../utils/languageManager';

// 卡片组件列表容器
const CardComponent = ({ onClose, onSave, initialData }) => {
  const cards = [
    { id: 'hot-search', component: HotSearch, title: languageManager.t('cards.hotSearch') },
    { id: 'daily-english', component: DailyEnglish, title: languageManager.t('cards.dailyEnglish') }
  ];

  return (
    <div className="card-component__tab-content">
      <div className="card-component__container">
        <div className="card-component__grid">
          {cards.map(({ id, component: Component, title }) => (
            <div key={id} className="card-component__wrapper">
              <Component onSave={onSave} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CardComponent; 